var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_00000128467100644212127330000001076375636510423199_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 590.4,
    x2: 500,
    y2: 90.4,
    gradientTransform: "matrix(1 0 0 -1 0 590.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#002385"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E9FE"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 500,
    height: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.1,221.6c15.7,15.7,15.7,41.4,0,57.5c-15.7,16-41.4,15.7-57.5,0c-16-15.7-15.7-41.4,0-57.5 S262.4,205.9,278.1,221.6z M307.5,307.5c-31.8,31.8-83.2,31.8-115,0s-31.8-83.2,0-115c27.1-26.7,67.8-31.1,99.3-12.4l54.8-54.8 c-61.8-48.1-151.1-43.8-207.9,13c-61.5,61.5-61.5,161.1,0,222.6s161.1,61.5,222.6,0c56.5-56.5,61.2-144.7,14-206.6l-55.1,55.1 C338.2,240.3,333.9,280.7,307.5,307.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3528fc7217b78b8608f7240b292be357.svg";
export { ForwardRef as ReactComponent };